import React from 'react';
import type { ReactElement, PropsWithoutRef } from 'react';

type Props = {
	title?: string;
};

export default function Heading({ title }: PropsWithoutRef<Props>): ReactElement {
	return (
		<div className="Heading">
			<div className="Heading-Title text-subtitle1">
				<span className="text-text-heading">{title}</span>
			</div>
		</div>
	);
}
